import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const testimonials = [
  {
    name: "Jean Dupont",
    title: "Agriculteur céréalier",
    location: "Normandie",
    content: "Grâce à SaTeCO+, j'ai réduit mes coûts en engrais de 30% tout en augmentant mes rendements. Les cartes de fertilité sont extrêmement précises."
  },
  {
    name: "Marie Leblanc",
    title: "Viticultrice",
    location: "Bordeaux",
    content: "La surveillance des cultures en temps réel m'a permis d'anticiper des problèmes d'hydratation. Un outil indispensable pour mon domaine."
  },
  {
    name: "Pierre Martin",
    title: "Maraîcher",
    location: "Provence",
    content: "Les analyses de sol rapides et les recommandations personnalisées ont transformé ma façon de travailler. Je recommande vivement GUIRETTE."
  }
];

const Testimonials = () => {
  return (
    <section className="py-5 bg-light">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col lg={8} className="text-center">
            <h2 className="fw-bold mb-3">Témoignages</h2>
            <p className="lead">
              Découvrez ce que disent les agriculteurs qui utilisent déjà SaTeCO+
            </p>
          </Col>
        </Row>
        
        <Row>
          {testimonials.map((testimonial, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <blockquote className="blockquote mb-0">
                    <p>{testimonial.content}</p>
                    <footer className="blockquote-footer mt-3">
                      <strong>{testimonial.name}</strong>, {testimonial.title}
                      <br />
                      <small>{testimonial.location}</small>
                    </footer>
                  </blockquote>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Testimonials;